import React, { useEffect, useState } from 'react';
import MapStyle from '../MapStyle';
import LocationMarker from './LocationMarker';
import { GoogleMap } from '@react-google-maps/api';

const google = window.google;

const LocationMap = (props) => {
    const { onLocationSelect, locations, listHover } = props;
    const [coordinates, setCoordinates] = useState();

    useEffect(() => {
        if (locations?.length > 0) {
            let location = locations[0];
            setCoordinates({ lat: parseFloat(location.addressLatitude), lng: parseFloat(location.addressLongitude) });
        }
    }, [locations]);

    return (
        <GoogleMap
            center={coordinates}
            zoom={12}
            mapContainerClassName={'ss-old-location-map'}
            options={{
                styles: MapStyle,
                mapTypeControl: true,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                },
            }}>
            {
                locations?.length > 0 && locations.map((location, idx) => {
                    return (
                        <LocationMarker
                            key={idx}
                            onLocationSelect={onLocationSelect}
                            location={location}
                            listHover={listHover}
                        />)
                })
            }
        </GoogleMap>
    )
};

export default LocationMap;
